<div class="p-grid" style="display: flex; justify-content: center;">
  <!-- <div class="p-col-4 p-md-4 p-sm-12">
    <p-card class="p-card--noshadow padding-min">
      <div class="container-center">
        <img src="https://placehold.co/2560x1440" style="width: 100%; height: auto;" />
      </div>
    </p-card>
  </div> -->

  <div class="p-col-10 p-sm-10">
    <div class="p-grid">
      <div class="p-col-12 p-sm-6 p-md-4" *ngFor="let menuItem of menuItems">
        <ng-container *ngIf="menuItem.active">
          <p-card class="p-card--noshadow p-card--menu" [routerLink]="menuItem.routerLink">
            <div class="menu-item--container">
              <div class="menu-item--icon">
                <img [src]="menuItem.img" alt="Snow" />
              </div>
              <div class="menu-item--title">
                <h3 style="font-weight: 400; font-family: 'Roboto'; text-transform: uppercase; font-size: 14px;">{{
                  menuItem.label }}</h3>
              </div>
              <div class="menu-item--arrow">
                <i class="pi pi-angle-right"></i>
              </div>
            </div>
          </p-card>
        </ng-container>
      </div>
    </div>
  </div>

</div>